import React, {useCallback, useEffect, useState} from 'react';
import {DataGrid, GridOverlay} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import * as CryptoJS from "crypto-js";
import './AssetInfo.css';
import './AssetList.css';
import {Box, Pagination} from '@mui/material';
import Select from "react-select";
import {Parser} from "json2csv";
import FromFieldDate from "../../../atoms/FromFieldDate";
import {getNotCapitalized, getNotCapitalizedCSV} from '../../../services/asset.service';
import {getDivisionAdditionalList} from '../../../services/user.service';

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
};

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

const NotCapitalizedList = () => {

    /* ─── Columns (backend unchanged – only renderCell class names updated) ─── */
    const columns = [
        {field: "sl_no", hideable: true, hide: true, editable: false, headerName: "Sl No", width: 50},
        {field: 'tag', editable: false, hide: false, headerName: 'TAG', width: 280,
            renderCell: (params) => {
                let encryptedTag = CryptoJS.AES.encrypt(JSON.stringify({
                    'tag': params.value, 'sl_no': params.row.sl_no,
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return <a className="al-cell-tag-link" href={`/assets-capitalization-view?tag=${encryptedTag}`}>{params.value}</a>;
            }
        },
        {field: "parent_tag", hideable: true, hide: false, editable: true, headerName: "Parent TAG", width: 280},
        {
            field: "asset_in_use_date", editable: true, hide: false, headerName: "Date of Capitalization / Asset Ready To Use", width: 230,
            renderCell: (params) => <p>{params.value ? getFormatedDate(params.value) : ''}</p>
        },
        {field: "cap_type_of_asset", editable: true, hide: false, headerName: "Type of Asset", width: 230},
        {field: "type_of_depreciation", editable: true, hide: false, headerName: "Type of Depreciation", width: 230},
        {
            field: "depreciation_end_date", editable: true, hide: false, headerName: "End Date", width: 230,
            renderCell: (params) => <p>{getFormatedDate(params.row.depreciation_end_date)}</p>
        },
        {field: "depreciation_rate", editable: true, hide: false, headerName: "Depreciation Rate (No. of years)", width: 230},
        {field: "accounting_code", editable: true, hide: false, headerName: "Accounting Code of Asset", width: 230},
        {field: "accounting_name", editable: true, hide: false, headerName: "Accounting Name of the Asset", width: 230},
        {field: "category_name", editable: true, hide: false, headerName: "Financials Classification", width: 230},
        {field: "class_of_asset", editable: true, hide: false, headerName: "Class of Asset", width: 230},
        {field: "capitalization_flag", editable: true, hide: false, headerName: "Final Asset Capitalization Flag", width: 230},
        {field: "is_tax_capitalized", editable: true, hide: false, headerName: "Is Tax Capitalized", width: 230},
        {field: "is_100_perc_depreciable", editable: true, hide: false, headerName: "Is 100% Depreciable Asset", width: 230},
        {field: "pre_capitalized_asset_value", editable: true, hide: false, headerName: "Pre Capitalized Asset Value", width: 230},
        {field: "is_any_other_accg_gaap_applicable", editable: false, hide: false, headerName: "Is any other Accg GAAP Applicable", width: 280},
        {
            field: "igaap_limit_amount", editable: true, hide: false, headerName: "I-GAAP - Limit for 100% Depreciable Asset (Rs)", width: 350,
            renderCell: (params) => <p>{parseFloat(params.row.igaap_limit_amount).toFixed(2)}</p>
        },
        {field: "othergaap_limit_amount", editable: true, hide: false, headerName: "Other-GAAP - Limit for 100% Depreciable Asset (Rs)", width: 350},
        {field: "salvage_value", editable: true, hide: false, headerName: "Salvage Value", width: 230},
        {field: "igaap_capitalized_value", editable: true, hide: false, headerName: "Capitalized Value (I-GAAP)", width: 230},
        {field: "othergaap_capitalized_value", editable: true, hide: false, headerName: "Capitalized Value (Other GAAP)", width: 230},
        {field: "cap_exchange_rate", editable: true, hide: true, headerName: "exchange rate", width: 230},
        {
            field: "record_start_date", editable: true, hide: true, headerName: "Record Start Date", width: 230,
            renderCell: (params) => <p>{getFormatedDate(params.row.record_start_date)}</p>
        },
        {
            field: "put_to_use_date", editable: true, hide: true, headerName: "Put to Use Date", width: 230,
            renderCell: (params) => <p>{getFormatedDate(params.row.put_to_use_date)}</p>
        },
        {
            field: "created_at", editable: false, hide: false, headerName: "Created Date", width: 180,
            renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>
        },
    ];

    const CustomLoader = () => (
        <GridOverlay>
            <CircularProgress color="primary" size={30}/>
        </GridOverlay>
    );

    /* ─── All State (identical to original) ─── */
    const [items, setItems]                                   = useState([]);
    const [itemsCSV, setItemsCSV]                             = useState([]);
    const [searchTag, setSearchTag]                           = useState('');
    const [ErrSearchTag, setErrSearchTag]                     = useState(false);
    const [loading, setLoading]                               = useState(true);
    const [exloading, setExLoading]                           = useState(false);
    const [page, setPage]                                     = useState(1);
    const [totalItems, setTotalItems]                         = useState(0);
    const [pageSize, setPageSize]                             = useState(50);
    const [filterCriteria, setFilterCriteria]                 = useState('');
    const [ErrFilterCriteria, setErrFilterCriteria]           = useState(false);
    const [filterOperator, setFilterOperator]                 = useState('');
    const [ErrFilterOperator, setErrFilterOperator]           = useState(false);
    const [startDate, setStartDate]                           = useState('');
    const [ErrStartDate, setErrStartDate]                     = useState(false);
    const [endDate, setEndDate]                               = useState('');
    const [ErrEndDate, setErrEndDate]                         = useState(false);
    const [otherDivisions, setOtherDivisions]                 = useState([]);
    const [selectedOtherDivisions, setSelectedOtherDivisions] = useState([]);
    const [hasData, setHasData]                               = useState(false);

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    /* ─── All Handlers (identical logic to original) ─── */
    const fetchAssets = useCallback(async () => {
        setLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {'offset': offset, 'pageSize': pageSize},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getNotCapitalized({token: encryptedData});
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems('');
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    }, [page, pageSize]);

    const fetchAssets1 = async () => {
        setLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {'offset': offset, 'pageSize': pageSize, 'searchTag': searchTag, 'filterCriteria': filterCriteria, 'filterOperator': filterOperator, 'startDate': startDate, 'endDate': endDate},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getNotCapitalized({token: encryptedData});
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems('');
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAssetsCSV = useCallback(async () => {
        setExLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {offset, pageSize, searchTag, filterCriteria, filterOperator, startDate: getFormatedDate(startDate), endDate: getFormatedDate(endDate)},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const resCSV = await getNotCapitalizedCSV({token: encryptedData});
            if (resCSV?.data?.data?.length) {
                setItemsCSV(resCSV.data.data);
                setHasData(true);
            } else {
                setHasData(false);
            }
        } catch (error) {
            console.error('Error fetching assets CSV:', error);
        } finally {
            setExLoading(false);
        }
    }, [filterCriteria, filterOperator, searchTag, startDate, endDate, page, pageSize]);

    useEffect(() => { fetchAssets(page, pageSize); }, []);

    useEffect(() => { if (itemsCSV.length > 0) generateCSV(); }, [itemsCSV]);

    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {'other_division_ids': sessionStorage.getItem('LoggedInOtherDivisionIds')},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        getDivisionAdditionalList({'token': EncryptData}).then(res => {
            if (res?.data?.data?.length) setOtherDivisions(res.data.data);
        });
    }, []);

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
        if (filterCriteria) fetchAssets1(1, value);
        else fetchAssets(1, value);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        if (filterCriteria) fetchAssets1(value, pageSize);
        else fetchAssets(value, pageSize);
    };

    const totalPages = Math.ceil(totalItems / pageSize);

    const handleExportToCSV = async () => {
        await fetchAssetsCSV();
        if (hasData) generateCSV();
    };

    const generateCSV = () => {
        try {
            const jsonData = itemsCSV.map(item => ({
                Tag: item.tag || '', Parent_TAG: item.parent_tag || '',
                Date_of_Capitalization: item.asset_in_use_date ? getFormatedDate(item.asset_in_use_date) : '',
                Type_of_Depreciation: item.cap_type_of_asset || '',
                End_Date: item.depreciation_end_date ? getFormatedDate(item.depreciation_end_date) : '',
                Depreciation_Rate: item.depreciation_rate || '',
                Accounting_Code_of_Asset: item.accounting_code || '',
                Accounting_Name_of_the_Asset: item.accounting_name || '',
                Financials_Classification: item.category_name || '',
                Final_Asset_Capitalization_Flag: item.capitalization_flag || '',
                Class_of_Asset: item.class_of_asset || '',
                Is_Tax_Capitalized: item.is_tax_capitalized || '',
                Is_100_Depreciable_Asset: item.is_100_perc_depreciable || '',
                Pre_Capitalized_Asset_Value: item.pre_capitalized_asset_value || '',
                Is_Any_Other_Accg_GAAP_Applicable: item.is_any_other_accg_gaap_applicable || '',
                IGAAP_Limit_for_100_Depreciable_Asset: item.igaap_limit_amount || '',
                Other_GAAP_Limit_for_100_Depreciable_Asset: item.othergaap_limit_amount || '',
                Salvage_Value: item.salvage_value || '',
                Capitalized_Value_I_GAAP: item.igaap_capitalized_value || '',
                Capitalized_Value_Other_GAAP: item.othergaap_capitalized_value || '',
                Exchange_Rate: item.cap_exchange_rate || '',
                Record_Start_Date: item.record_start_date ? getFormatedDate(item.record_start_date) : '',
                Put_to_Use_Date: item.put_to_use_date ? getFormatedDate(item.put_to_use_date) : '',
                Created_Date: item.created_at ? getFormatedDate(item.created_at) : '',
            }));
            const json2csvParser = new Parser();
            const csv = json2csvParser.parse(jsonData);
            const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Capitalized_List.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data to CSV:', error);
        }
    };

    const handleSearch = () => {
        let isValid = true;
        if (!filterCriteria) { setErrFilterCriteria('Please select a filter criteria'); isValid = false; } else setErrFilterCriteria('');
        if (filterCriteria !== 'created_at' && !filterOperator) { setErrFilterOperator('Please select a filter operator'); isValid = false; } else setErrFilterOperator('');
        if (!searchTag && filterCriteria != 'created_at') { setErrSearchTag('Please enter a search text'); isValid = false; } else setErrSearchTag('');
        if (!startDate && filterCriteria == 'created_at') { setErrStartDate('Please select start date'); isValid = false; } else setErrStartDate('');
        if (!endDate && filterCriteria == 'created_at') { setErrEndDate('Please select end date'); isValid = false; } else setErrEndDate('');
        if (isValid) { setPage(1); fetchAssets1(); }
    };

    const options = ["TAG Number", "Year Of Addition", "Type of Addition", "PO Number", "Supplier Name", "Invoice Number", "Asset Name", "Make", "Model Number", "Asset Serial Number", "Part Number", "TAG Name", "Nature of Presence", "Date Range"];
    const values = ["tag", "year_of_addition", "type_of_addition", "po_no", "supplier_name", "invoice_no", "asset_name", "manufacturer", "model_no", "asset_serial_no", "part_no", "tag_name", "nature_of_presence", "created_at"];
    const combinedOptions = options.map((option, index) => ({label: option, value: values[index]}));

    const handleSelectChange = (e) => {
        const selectedOption = combinedOptions.find(option => option.value === e.target.value);
        setFilterCriteria(selectedOption ? selectedOption.value : '');
        setErrFilterCriteria('');
    };

    const optionsFilter = ["Contains", "Equals", "Not Contains", "Not Equals", "Blank", "Non Blank"];
    const valuesFilter = ["LIKE", "=", "NOT LIKE", "!=", "IS NULL", "IS NOT NULL"];
    const combinedOptionsFilter = optionsFilter.map((option, index) => ({label: option, value: valuesFilter[index]}));

    const handleOperatorChange = (e) => { setFilterOperator(e.target.value); setErrFilterOperator(''); };
    const handelSearchText = (e) => { setSearchTag(e.target.value); };

    const otherDivisionOptions = otherDivisions.map(option => ({value: option.id, label: option.division_name}));
    const handleOtherDivisions = (selectedOptions) => { setSelectedOtherDivisions(selectedOptions || []); };
    const otherDivisionIds = selectedOtherDivisions.map(option => option.value);

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="capitalized-list-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-cash-coin"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Not Capitalized Assets List</h5>
                        <p className="al-page-subtitle">View and manage Not capitalized asset records</p>
                    </div>
                </div>
                {!loading && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill"/>
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ FILTER PANEL ══ */}
            <div className="al-filter-card" id="al-filter-panel">
                <div className="al-filter-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-funnel-fill"/> Search &amp; Filter
                    </span>
                </div>
                <div className="al-filter-card-body">

                    {/* Branch selector */}
                    {otherDivisionOptions.length > 0 && (
                        <div className="al-filter-row" id="al-branch-row">
                            <label className="al-filter-label">
                                <i className="bi bi-geo-alt-fill"/> Branch (Division)
                            </label>
                            <div className="al-filter-control-full">
                                <Select
                                    options={otherDivisionOptions}
                                    isMulti
                                    placeholder="Select one or more branches…"
                                    value={selectedOtherDivisions}
                                    onChange={handleOtherDivisions}
                                    classNamePrefix="al-select"
                                />
                            </div>
                        </div>
                    )}

                    {/* Criteria / Operator / Value */}
                    <div className="al-filter-grid" id="al-filter-grid">
                        <div className="al-filter-group">
                            <label className="al-filter-label">
                                Select Criteria <span className="al-required-star">*</span>
                            </label>
                            <select className="al-form-select" value={filterCriteria} onChange={handleSelectChange}>
                                <option value="" disabled>Select Filter Criteria</option>
                                {combinedOptions.map((opt, i) => (
                                    <option key={i} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            {ErrFilterCriteria && <span className="al-field-error"><i className="bi bi-exclamation-circle"/> {ErrFilterCriteria}</span>}
                        </div>

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group">
                                <label className="al-filter-label">
                                    Select Operator <span className="al-required-star">*</span>
                                </label>
                                <select className="al-form-select" value={filterOperator} onChange={handleOperatorChange}>
                                    <option value="" disabled>Select Operator</option>
                                    {combinedOptionsFilter.map((opt, i) => (
                                        <option key={i} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                                {ErrFilterOperator && <span className="al-field-error"><i className="bi bi-exclamation-circle"/> {ErrFilterOperator}</span>}
                            </div>
                        )}

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group al-filter-group-wide">
                                <label className="al-filter-label">
                                    Enter Criteria <span className="al-required-star">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="al-form-input"
                                    placeholder="Type search value…"
                                    inputValue={searchTag}
                                    onChange={handelSearchText}
                                />
                                {ErrSearchTag && <span className="al-field-error"><i className="bi bi-exclamation-circle"/> {ErrSearchTag}</span>}
                            </div>
                        )}
                    </div>

                    {/* Date range */}
                    {filterCriteria === 'created_at' && (
                        <div className="al-date-grid" id="al-date-grid">
                            <div className="al-filter-group">
                                <FromFieldDate label="Start Date" placeholder="Select Start Date"
                                               inputValue={startDate} setInputValue={setStartDate} setErrorMsg={ErrStartDate}/>
                            </div>
                            <div className="al-filter-group">
                                <FromFieldDate label="End Date" placeholder="Select End Date"
                                               inputValue={endDate} setInputValue={setEndDate} setErrorMsg={ErrEndDate}/>
                            </div>
                        </div>
                    )}

                    {/* Buttons */}
                    <div className="al-filter-actions" id="al-filter-actions">
                        <button className="al-btn al-btn-primary" id="al-search-btn" onClick={handleSearch}>
                            <i className="bi bi-search"/> Search Assets
                        </button>
                        <button className="al-btn al-btn-outline" id="al-export-btn" onClick={handleExportToCSV} disabled={exloading}>
                            {exloading ? (
                                <><span className="al-dot"/><span className="al-dot"/><span className="al-dot"/> Exporting…</>
                            ) : (
                                <><i className="bi bi-file-earmark-arrow-down"/> Export All to CSV</>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table"/> Capitalized Asset Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.sl_no}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Pagination: () => (
                                <Box className="al-pagination-bar">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <Select
                                            options={[
                                                {value: 10, label: '10'}, {value: 25, label: '25'},
                                                {value: 50, label: '50'}, {value: 100, label: '100'},
                                                {value: 200, label: '200'}, {value: 500, label: '500'},
                                            ]}
                                            value={{value: pageSize, label: pageSize.toString()}}
                                            onChange={(sel) => handlePageSizeChange(sel.value)}
                                            classNamePrefix="al-select"
                                            menuPlacement="top"
                                            styles={{container: (b) => ({...b, minWidth: 80})}}
                                        />
                                    </div>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                        sx={{
                            border: 'none',
                            fontFamily: "var(--font-body)",
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                            },
                            '& .MuiDataGrid-columnHeaderTitle':    {color: '#000',fontSize: '0.88rem'},
                            '& .MuiDataGrid-sortIcon': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-menuIconButton': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': {color: 'rgba(255,255,255,0.85)'},
                            '& .MuiDataGrid-row':                  {fontSize: '0.8rem'},
                            '& .MuiDataGrid-row:hover':            {backgroundColor: '#eef7fd'},
                            '& .MuiDataGrid-row.Mui-selected':     {backgroundColor: '#d8f0fa'},
                            '& .MuiDataGrid-cell':                 {borderColor: '#f0f2f5'},
                            '& .MuiDataGrid-footerContainer':      {borderTop: '1px solid #e2e6ef', background: '#f8f9fc'},
                            '& .MuiDataGrid-virtualScroller':      {backgroundColor: '#fff'},
                        }}
                    />
                </Box>
            </div>
        </div>
    );
};

export default NotCapitalizedList;